import"./chunk-PXDN3KFO.js";var e=t=>{var s,c;if(!t)return"";let n=t.trim().split(/\s+/),i=((s=n[0])==null?void 0:s.charAt(0))||"",r=((c=n[1])==null?void 0:c.charAt(0))||"";return r?`${i} ${r}`:`${i}`};export{e as getInitials};
